import { FormattedMessage } from 'react-intl';

import close from '@/public/images/icons/x.svg';

const UnitFilterPop = (props: any) => {
  const {
    onCheckBoxClick,
    featuredChecked,
    smallChecked,
    mediumChecked,
    largeChecked,
    heatedChecked,
    climateControlledChecked,
    driveupChecked,
    parkingChecked,
    xlargeChecked,
    officeChecked,
    uniqueUnitTypes,
    smallBlur,
    mediumBlur,
    largeBlur,
    xlargeBlur,
    officeBlur,
    parkingBlur,
    heatedBlur,
    climateControlledBlur,
    driveupBlur,
    indoorcarChecked,
    indoorcarBlur,
    locale,
  } = props;

  const labelClass = (isChecked: boolean, isBlur: boolean) => {
    return `${
      isChecked
        ? 'sv-checkbox-checked-label form-check-label '
        : 'form-check-label '
    }${isBlur ? 'form-check-label-disabled' : ''}`;
  };

  const secondaryLabelClass = (isChecked: boolean, isBlur: boolean) => {
    return `${
      isChecked
        ? 'form-check-secondary-label form-check-secondary-label-visible '
        : 'form-check-secondary-label '
    }
    ${isBlur ? 'form-check-secondary-label-disabled' : ''}`;
  };

  const handleCloseClick = (e: any) => {
    e.preventDefault();
  };

  return (
    <>
      <div className="modal fade" id="SvFilterModalUnit">
        <div className="modal-dialog modal-dialog-centered bg-transparent">
          <div className="modal-content rounded-3 bg-transparent">
            <div className="sv-filter-container bg-transparent">
              <div className="closebtn">
                <img
                  src={close.src}
                  alt="close"
                  className="sv-close-btn"
                  data-bs-dismiss="modal"
                />
              </div>
              <div className="sv-size-help-guide border-0 shadow-none">
                <div className="sv-filter-type-container">
                  <h6 className="filter-section-title">
                    <FormattedMessage id="filters.selfStorage" />
                  </h6>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="Featured"
                      checked={featuredChecked}
                      onChange={(e) => onCheckBoxClick(e)}
                    />
                    <div className="label-container">
                      <label
                        htmlFor=""
                        className={
                          featuredChecked
                            ? 'sv-checkbox-checked-label form-check-label '
                            : 'form-check-label'
                        }
                      >
                        <FormattedMessage id="sectionName.featuedUnits" />
                      </label>
                      <div
                        className={
                          featuredChecked
                            ? 'form-check-secondary-label form-check-secondary-label-visible'
                            : 'form-check-secondary-label'
                        }
                      >
                        <FormattedMessage id="filters.mostPopular" />
                      </div>
                    </div>
                  </div>
                  {uniqueUnitTypes.includes('Small') && (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="Small"
                        checked={smallChecked}
                        onChange={(e) => onCheckBoxClick(e)}
                        disabled={smallBlur}
                      />
                      <div className="label-container">
                        <label
                          htmlFor="flexCheckDefault"
                          className={labelClass(smallChecked, smallBlur)}
                        >
                          <FormattedMessage id="sectionName.small" />
                        </label>
                        <div
                          className={secondaryLabelClass(
                            smallChecked,
                            smallBlur
                          )}
                        >
                          <FormattedMessage id="filters.seasonalItems" />
                        </div>
                      </div>
                    </div>
                  )}
                  {uniqueUnitTypes.includes('Medium') && (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="Medium"
                        checked={mediumChecked}
                        onChange={(e) => onCheckBoxClick(e)}
                        disabled={mediumBlur}
                      />
                      <div className="label-container">
                        <label
                          htmlFor="flexCheckDefault"
                          className={labelClass(mediumChecked, mediumBlur)}
                        >
                          <FormattedMessage id="sectionName.medium" />
                        </label>
                        <div
                          className={secondaryLabelClass(
                            mediumChecked,
                            mediumBlur
                          )}
                        >
                          <FormattedMessage id="filters.studioApartment" />
                        </div>
                      </div>
                    </div>
                  )}
                  {uniqueUnitTypes.includes('Large') && (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="Large"
                        checked={largeChecked}
                        onChange={(e) => onCheckBoxClick(e)}
                        disabled={largeBlur}
                      />
                      <div className="label-container">
                        <label
                          htmlFor="flexCheckDefault"
                          className={labelClass(largeChecked, largeBlur)}
                        >
                          <FormattedMessage id="sectionName.large" />
                        </label>
                        <div
                          className={secondaryLabelClass(
                            largeChecked,
                            largeBlur
                          )}
                        >
                          <FormattedMessage id="filters.2-4Bedroom" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {(!indoorcarBlur || !parkingBlur) && (
                  <div className="sv-filter-type-container">
                    <h6 className="filter-section-title">
                      <FormattedMessage id="vehicle-storage" />
                    </h6>

                    {!parkingBlur && (
                      <>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value="parking"
                            checked={parkingChecked}
                            onChange={(e) => onCheckBoxClick(e)}
                            disabled={parkingBlur}
                          />
                          <div className="label-container">
                            <label
                              htmlFor="flexCheckDefault"
                              className={labelClass(
                                parkingChecked,
                                parkingBlur
                              )}
                            >
                              <FormattedMessage id="sectionName.outdoorParking" />
                            </label>
                            <div
                              className={secondaryLabelClass(
                                parkingChecked,
                                parkingBlur
                              )}
                            >
                              <FormattedMessage id="filters.rvAndOversized" />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {!indoorcarBlur && (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value="indoorcar"
                          checked={indoorcarChecked}
                          onChange={(e) => onCheckBoxClick(e)}
                          disabled={indoorcarBlur}
                        />
                        <div className="label-container">
                          <label
                            htmlFor="flexCheckDefault"
                            className={labelClass(
                              indoorcarChecked,
                              indoorcarBlur
                            )}
                          >
                            <FormattedMessage id="sectionName.indoorCarStorage" />
                            <div
                              className={secondaryLabelClass(
                                indoorcarChecked,
                                indoorcarBlur
                              )}
                            >
                              <FormattedMessage id="filters.carsAndMotor" />
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {(uniqueUnitTypes.includes('office') ||
                  uniqueUnitTypes.includes('xLarge')) && (
                  <div className="sv-filter-type-container">
                    <h6 className="filter-section-title">Commercial</h6>
                    {uniqueUnitTypes.includes('office') && (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value="office"
                          checked={officeChecked}
                          onChange={(e) => onCheckBoxClick(e)}
                          disabled={officeBlur}
                        />
                        <div className="label-container">
                          <label
                            htmlFor="flexCheckDefault"
                            className={labelClass(officeChecked, officeBlur)}
                          >
                            <FormattedMessage id="office-space" />
                          </label>
                          <div
                            className={secondaryLabelClass(
                              officeChecked,
                              officeBlur
                            )}
                          >
                            <FormattedMessage id="filters.officeEquipment" />
                          </div>
                        </div>
                      </div>
                    )}
                    {uniqueUnitTypes.includes('xLarge') && (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value="xLarge"
                          checked={xlargeChecked}
                          onChange={(e) => onCheckBoxClick(e)}
                          disabled={xlargeBlur}
                        />
                        <div className="label-container">
                          <label
                            htmlFor="flexCheckDefault"
                            className={labelClass(xlargeChecked, xlargeBlur)}
                          >
                            <FormattedMessage id="sectionName.xlarge" />
                          </label>
                          <div
                            className={secondaryLabelClass(
                              xlargeChecked,
                              xlargeBlur
                            )}
                          >
                            <FormattedMessage id="filters.toolsAndEquipment" />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="sv-size-help-guide">
                <div className="sv-filter-type-container">
                  <h6 className="filter-section-title">
                    <FormattedMessage id="filters.UnitFeatures" />
                  </h6>
                  {uniqueUnitTypes.includes('climateControlled') && (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="climateControlled"
                        checked={climateControlledChecked}
                        onChange={(e) => onCheckBoxClick(e)}
                        disabled={climateControlledBlur}
                      />
                      <div className="label-container">
                        <label
                          htmlFor="flexCheckDefault"
                          className={labelClass(
                            climateControlledChecked,
                            climateControlledBlur
                          )}
                        >
                          <FormattedMessage id="filters.climateControlled" />
                        </label>
                        <div
                          className={secondaryLabelClass(
                            climateControlledChecked,
                            climateControlledBlur
                          )}
                        >
                          <FormattedMessage id="filters.protectFromHotAndCold" />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="heated"
                      checked={heatedChecked}
                      onChange={(e) => onCheckBoxClick(e)}
                      disabled={heatedBlur}
                    />
                    <div className="label-container">
                      <label
                        htmlFor="flexCheckDefault"
                        className={labelClass(heatedChecked, heatedBlur)}
                      >
                        <FormattedMessage id="filters.heated" />
                      </label>
                      <div
                        className={secondaryLabelClass(
                          heatedChecked,
                          heatedBlur
                        )}
                      >
                        <FormattedMessage id="filters.protectFromWinter" />
                      </div>
                    </div>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="driveUp"
                      checked={driveupChecked}
                      onChange={(e) => onCheckBoxClick(e)}
                      disabled={driveupBlur}
                    />
                    <div className="label-container">
                      <label
                        htmlFor="flexCheckDefault"
                        className={labelClass(driveupChecked, driveupBlur)}
                      >
                        <FormattedMessage id="filters.driveup" />
                      </label>
                      <div
                        className={secondaryLabelClass(
                          driveupChecked,
                          driveupBlur
                        )}
                      >
                        <FormattedMessage id="filters.accessFromOutside" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sv-filter-buttons-container">
                <button
                  className={
                    locale === 'en'
                      ? 'btn sv-filter-btn text-capitalize'
                      : 'btn sv-filter-btn text-normal'
                  }
                  type="button"
                  onClick={() =>
                    onCheckBoxClick({
                      target: { value: 'clear', checked: true },
                    })
                  }
                >
                  <FormattedMessage id="filters.clearAll" />
                </button>
                <button
                  className={
                    locale === 'en'
                      ? 'btn sv-search-btn text-uppercase'
                      : 'btn sv-search-btn'
                  }
                  type="button"
                  data-bs-dismiss="modal"
                  onClick={handleCloseClick}
                >
                  <FormattedMessage id="buttons.search" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnitFilterPop;
